const ITEMS = [
    "Institutional Trend Flow",
    "High-volume markets",
    "Bullish flow",
    "Bearish flow",
    "Price structure",
    "Market behavior",
    "One line. One direction.",
    "Built for TradingView",
    "Intraday · 5m optimized",
];

function Diamond() {
    return (
        <svg width="8" height="8" viewBox="0 0 8 8" className="mx-6 shrink-0 text-emerald-500" fill="currentColor">
            <rect x="1.5" y="1.5" width="5" height="5" transform="rotate(45 4 4)" />
        </svg>
    );
}

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div className="overflow-hidden border-y border-slate-200/70 bg-white py-4" data-testid="editorial-marquee">
            <div className="animate-marquee-x flex w-max items-center">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center whitespace-nowrap">
                        <span className="font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-slate-500">{item}</span>
                        <Diamond />
                    </span>
                ))}
            </div>
        </div>
    );
}
